import floatLabels from '../globals/forms';
import {setVarsOnResize} from '../globals/height';
import preventOverflow from '../globals/prevent-overflow';
import resizeListener from '../globals/resize';
import scrollListener from '../globals/scroll';
import isTouch from '../util/touch';
import {lazyImageBackgrounds, videoPopups, ariaToggle} from '../globals/legacy';

resizeListener();
scrollListener();
isTouch();
lazyImageBackgrounds();

window.addEventListener('load', () => {
  setVarsOnResize();
  floatLabels(document);
  preventOverflow(document);
  videoPopups(document);
  ariaToggle(document);
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  floatLabels(container);
  preventOverflow(container);
  videoPopups(container);
  ariaToggle(document);
});
